module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-28GENNAIO-25-OK-935d53bbf4d71ed9b4eaccc357aeb553.jpg";